import { ButtonProps, InputProps, NativeSelectFieldProps, TextareaProps } from '@chakra-ui/react'
import { FormContainerProps } from '@src/components/sco/FormContainer'
import { prettyErrorMessage } from '@src/lib/mutationErrors'

export type GenericFormProps<TFormData> = {
  afterError?: (values: TFormData, error?: any, errorMessage?: any) => Promise<boolean> | any
  afterSuccess?: (values: TFormData, result?: any) => Promise<boolean> | any
  containerProps?: FormContainerProps
  handleSubmit?: (values: TFormData) => Promise<boolean> | any
  inputProps?: InputProps | NativeSelectFieldProps | TextareaProps
  onSubmit?: (values: TFormData) => Promise<boolean> | any
  returnToHref?: string
  submitButtonProps?: ButtonProps
}

type ProcessSubmitArgs<TFormFields> = {
  action: (values: TFormFields) => Promise<any>
  afterSuccess?: (values: any, result: any) => Promise<any>
  afterError?: (values: any, error: any, errorMessage: string) => Promise<any>
  values: any
  props: GenericFormProps<any>
  setFormErrorMessage?: (message: string) => void
}

export async function processSubmit<TFormFields>({
  action,
  afterSuccess,
  afterError,
  values,
  props,
  setFormErrorMessage,
}: ProcessSubmitArgs<TFormFields>) {
  if (setFormErrorMessage) {
    setFormErrorMessage(null)
  }

  let result = null
  let success = false
  let error = null
  let errorMessage = null

  try {
    if (props.onSubmit) {
      await props.onSubmit(values)
    }
    if (props.handleSubmit) {
      result = await props.handleSubmit(values)
    } else {
      result = await action(values)
    }

    success = true
  } catch (err) {
    success = false
    error = err
    errorMessage = prettyErrorMessage(err)
  }

  if (success) {
    if (afterSuccess) {
      await afterSuccess(values, result)
    } else if (props.afterSuccess) {
      props.afterSuccess(values, result)
    }
  } else {
    if (afterError) {
      await afterError(values, error, errorMessage)
    } else {
      if (props.afterError) {
        await props.afterError(values, error, errorMessage)
      }
    }

    if (errorMessage && setFormErrorMessage) {
      setFormErrorMessage(errorMessage)
    }
    return errorMessage
  }
}
